import '.f8{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.f9{padding-left:1.5rem;}.ssr-plugin'
import '.fa{margin:1rem 0;}.ssr-plugin'
import '.fb{color:var(--gray-700);}.ssr-plugin'
import '.fc{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="f8 f9 fa fb fc"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
